<template>
    <bita-modal
        :id="modalId"
        :title="title"
        :modal-lg="true"
        :isLoading="isLoading"
        @close="onCloseModal"
    >
    <div slot="body">
        <bita-form ref="form">
            <div slot="body">
                <div class="row">
                    <bita-multiselect
                        name="userselect"
                        ref="userRoleSelect"
                        label="نقش کاربری"
                        validation-container-class="col-12"
                        input-class="form-control"
                        :data-source="propsRoles"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="updateForm.role_name"
                    />
                </div>
            </div>
        </bita-form> 
    </div>
    <div slot="footer">
        <bita-bootbutton
            type="primary"
            title="بروزرسانی"
            icon="fa fa-check"
            btn-width="100px"
            @click.native="handleSubmit()"
        />
    </div>
    </bita-modal>
</template>
<script>
export default {
    props: {
        modalId: '',
        title: '',
        isLoading: '',
        propsData: {},
        propsRoles: [],
    },
    data() {
        return {
            updateForm: {},
        }
    },
    watch: {
        propsData: function(_data){
            this.updateForm = _data;
        },
    },
    methods: {
        onCloseModal() {

        },
        handleSubmit() {
            this.$emit("on-submit", this.updateForm);
        },
    }
}
</script>